/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for AccountStatementCtl controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, PagedModelAccountStatement } from "../models";

@Injectable({ providedIn: "root" })
export class AccountStatementCtlService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    getAccountStatement(idPartner: number, accountType?: string, startDate?: string, endDate?: string, page?: number, size?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<PagedModelAccountStatement>;
    getAccountStatement(idPartner: number, accountType?: string, startDate?: string, endDate?: string, page?: number, size?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PagedModelAccountStatement>>;
    getAccountStatement(idPartner: number, accountType?: string, startDate?: string, endDate?: string, page?: number, size?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PagedModelAccountStatement>>;
    getAccountStatement(idPartner: number, accountType?: string, startDate?: string, endDate?: string, page?: number, size?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/accounts/statements`;

        let params = new HttpParams();
        if (idPartner != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idPartner, 'idPartner');
        }
        if (accountType != null) {
            params = HttpParamsBuilder.addToHttpParams(params, accountType, 'accountType');
        }
        if (startDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, startDate, 'startDate');
        }
        if (endDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, endDate, 'endDate');
        }
        if (page != null) {
            params = HttpParamsBuilder.addToHttpParams(params, page, 'page');
        }
        if (size != null) {
            params = HttpParamsBuilder.addToHttpParams(params, size, 'size');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
